// modalTypes.js
export const MODAL_TYPES = {
  ROW_CONTROL: "ROW_CONTROL",
  FILTER_MENU: "FILTER_MENU"
};
